/**
 * Chat API
 * 
 * Handles chat-related API calls including:
 * - Image uploads
 */

import api from './client';

export const chatApi = {
  /**
   * Upload chat image
   * @param {FormData} formData - Form data with image file
   * @returns {Promise<Object>} Upload result with image URL
   */
  async uploadImage(formData) {
    const response = await api.post('/api/chat/upload', formData);
    return response.data;
  },
};

export default chatApi;
